import { TYPE_WELLS } from "constants/settings.constants";

export function getTitle(node, type) {
  const reserveCategory = node.reserveCategory ?? "";
  if (type == TYPE_WELLS) {
    return reserveCategory ? `${node.title} (${reserveCategory})` : node.title;
  }
  return node.title;
}
